/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusPaymentCouponDto } from './NovitusPaymentCouponDto';
import {
    NovitusPaymentCouponDtoFromJSON,
    NovitusPaymentCouponDtoFromJSONTyped,
    NovitusPaymentCouponDtoToJSON,
} from './NovitusPaymentCouponDto';
import type { NovitusPaymentOtherDto } from './NovitusPaymentOtherDto';
import {
    NovitusPaymentOtherDtoFromJSON,
    NovitusPaymentOtherDtoFromJSONTyped,
    NovitusPaymentOtherDtoToJSON,
} from './NovitusPaymentOtherDto';
import type { NovitusPaymentAccountDto } from './NovitusPaymentAccountDto';
import {
    NovitusPaymentAccountDtoFromJSON,
    NovitusPaymentAccountDtoFromJSONTyped,
    NovitusPaymentAccountDtoToJSON,
} from './NovitusPaymentAccountDto';
import type { NovitusPaymentCreditDto } from './NovitusPaymentCreditDto';
import {
    NovitusPaymentCreditDtoFromJSON,
    NovitusPaymentCreditDtoFromJSONTyped,
    NovitusPaymentCreditDtoToJSON,
} from './NovitusPaymentCreditDto';
import type { NovitusPaymentChequeDto } from './NovitusPaymentChequeDto';
import {
    NovitusPaymentChequeDtoFromJSON,
    NovitusPaymentChequeDtoFromJSONTyped,
    NovitusPaymentChequeDtoToJSON,
} from './NovitusPaymentChequeDto';
import type { NovitusPaymentTransferDto } from './NovitusPaymentTransferDto';
import {
    NovitusPaymentTransferDtoFromJSON,
    NovitusPaymentTransferDtoFromJSONTyped,
    NovitusPaymentTransferDtoToJSON,
} from './NovitusPaymentTransferDto';
import type { NovitusPaymentCardDto } from './NovitusPaymentCardDto';
import {
    NovitusPaymentCardDtoFromJSON,
    NovitusPaymentCardDtoFromJSONTyped,
    NovitusPaymentCardDtoToJSON,
} from './NovitusPaymentCardDto';
import type { NovitusPaymentVoucherDto } from './NovitusPaymentVoucherDto';
import {
    NovitusPaymentVoucherDtoFromJSON,
    NovitusPaymentVoucherDtoFromJSONTyped,
    NovitusPaymentVoucherDtoToJSON,
} from './NovitusPaymentVoucherDto';
import type { NovitusPaymentMobileDto } from './NovitusPaymentMobileDto';
import {
    NovitusPaymentMobileDtoFromJSON,
    NovitusPaymentMobileDtoFromJSONTyped,
    NovitusPaymentMobileDtoToJSON,
} from './NovitusPaymentMobileDto';
import type { NovitusPaymentCashDto } from './NovitusPaymentCashDto';
import {
    NovitusPaymentCashDtoFromJSON,
    NovitusPaymentCashDtoFromJSONTyped,
    NovitusPaymentCashDtoToJSON,
} from './NovitusPaymentCashDto';

/**
 * 
 * @export
 * @interface NovitusPaymentDto
 */
export interface NovitusPaymentDto {
    /**
     * Szczegóły płatności gotówką
     * @type {NovitusPaymentCashDto}
     * @memberof NovitusPaymentDto
     */
    cash?: NovitusPaymentCashDto;
    /**
     * Szczegóły płatności kartą
     * @type {NovitusPaymentCardDto}
     * @memberof NovitusPaymentDto
     */
    card?: NovitusPaymentCardDto;
    /**
     * Szczegóły płatności czekiem
     * @type {NovitusPaymentChequeDto}
     * @memberof NovitusPaymentDto
     */
    cheque?: NovitusPaymentChequeDto;
    /**
     * Szczegóły płatności kuponem
     * @type {NovitusPaymentCouponDto}
     * @memberof NovitusPaymentDto
     */
    coupon?: NovitusPaymentCouponDto;
    /**
     * Szczegóły innej formy płatności
     * @type {NovitusPaymentOtherDto}
     * @memberof NovitusPaymentDto
     */
    other?: NovitusPaymentOtherDto;
    /**
     * Szczegóły płatności kredytem
     * @type {NovitusPaymentCreditDto}
     * @memberof NovitusPaymentDto
     */
    credit?: NovitusPaymentCreditDto;
    /**
     * Szczegóły płatności na konto bankowe
     * @type {NovitusPaymentAccountDto}
     * @memberof NovitusPaymentDto
     */
    account?: NovitusPaymentAccountDto;
    /**
     * Szczegóły płatności przelewem bankowym
     * @type {NovitusPaymentTransferDto}
     * @memberof NovitusPaymentDto
     */
    transfer?: NovitusPaymentTransferDto;
    /**
     * Szczegóły płatności mobilnej/cyfrowej
     * @type {NovitusPaymentMobileDto}
     * @memberof NovitusPaymentDto
     */
    mobile?: NovitusPaymentMobileDto;
    /**
     * Szczegóły płatności bonem
     * @type {NovitusPaymentVoucherDto}
     * @memberof NovitusPaymentDto
     */
    voucher?: NovitusPaymentVoucherDto;
}

/**
 * Check if a given object implements the NovitusPaymentDto interface.
 */
export function instanceOfNovitusPaymentDto(value: object): value is NovitusPaymentDto {
    return true;
}

export function NovitusPaymentDtoFromJSON(json: any): NovitusPaymentDto {
    return NovitusPaymentDtoFromJSONTyped(json, false);
}

export function NovitusPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cash': json['cash'] == null ? undefined : NovitusPaymentCashDtoFromJSON(json['cash']),
        'card': json['card'] == null ? undefined : NovitusPaymentCardDtoFromJSON(json['card']),
        'cheque': json['cheque'] == null ? undefined : NovitusPaymentChequeDtoFromJSON(json['cheque']),
        'coupon': json['coupon'] == null ? undefined : NovitusPaymentCouponDtoFromJSON(json['coupon']),
        'other': json['other'] == null ? undefined : NovitusPaymentOtherDtoFromJSON(json['other']),
        'credit': json['credit'] == null ? undefined : NovitusPaymentCreditDtoFromJSON(json['credit']),
        'account': json['account'] == null ? undefined : NovitusPaymentAccountDtoFromJSON(json['account']),
        'transfer': json['transfer'] == null ? undefined : NovitusPaymentTransferDtoFromJSON(json['transfer']),
        'mobile': json['mobile'] == null ? undefined : NovitusPaymentMobileDtoFromJSON(json['mobile']),
        'voucher': json['voucher'] == null ? undefined : NovitusPaymentVoucherDtoFromJSON(json['voucher']),
    };
}

export function NovitusPaymentDtoToJSON(value?: NovitusPaymentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cash': NovitusPaymentCashDtoToJSON(value['cash']),
        'card': NovitusPaymentCardDtoToJSON(value['card']),
        'cheque': NovitusPaymentChequeDtoToJSON(value['cheque']),
        'coupon': NovitusPaymentCouponDtoToJSON(value['coupon']),
        'other': NovitusPaymentOtherDtoToJSON(value['other']),
        'credit': NovitusPaymentCreditDtoToJSON(value['credit']),
        'account': NovitusPaymentAccountDtoToJSON(value['account']),
        'transfer': NovitusPaymentTransferDtoToJSON(value['transfer']),
        'mobile': NovitusPaymentMobileDtoToJSON(value['mobile']),
        'voucher': NovitusPaymentVoucherDtoToJSON(value['voucher']),
    };
}

